import React, { useEffect, useState } from "react";

export default function Countdown({ target = "2026-07-19T19:00:00Z", label = "World Cup Final" }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, new Date(target).getTime() - now.getTime());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const mins = Math.floor((diff % 3600000) / 60000);
  const secs = Math.floor((diff % 60000) / 1000);

  const Cell = ({ v, k }) => (
    <div className="adn-card px-3 py-2 sm:px-5 sm:py-3 min-w-[70px] sm:min-w-[92px] text-center">
      <div className="font-bebas text-3xl sm:text-5xl gold-text leading-none" data-testid={`countdown-${k}`}>
        {String(v).padStart(2, "0")}
      </div>
      <div className="text-[10px] sm:text-xs tracking-[0.2em] text-adn-muted mt-1 uppercase text-adn-green/80">
        {k}
      </div>
    </div>
  );
  return (
    <div className="inline-flex flex-col items-center gap-3" data-testid="countdown">
      <div className="text-xs tracking-[0.25em] uppercase text-white/60">{label}</div>
      <div className="flex gap-2 sm:gap-3">
        <Cell v={days} k="days" />
        <Cell v={hours} k="hrs" />
        <Cell v={mins} k="min" />
        <Cell v={secs} k="sec" />
      </div>
    </div>
  );
}
